import React, { ReactElement, useState, useEffect, useRef } from "react";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { Translate } from "react-redux-i18n";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import MenuItem from "@mui/material/MenuItem";
import WalletChildrenSelect from "components/wallet/WalletChildrenSelect";
import {
  Wallet,
  WalletType,
  moveFundsRequested,
  PayloadTransfer,
  getFilteredSearchResultsRequested,
  clearSearchResult,
  getWalletRequested,
  getWalletSucceded
} from "../../../redux/wallet/walletSlice";
import { TransactionType } from "../../../redux/config/configSlice";
import { checkWalletPermissions } from 'services/utils'
import { NUMBER_REGEXP } from "../../../constants";
import styles from "./styles.module.scss";
import Typography from '@mui/material/Typography'
import Backdrop from "@mui/material/Backdrop";
function WalletAccountUtilities(): ReactElement {
  const dispatch = useAppDispatch();
  const walletAccountUtilitiesRef = useRef<HTMLElement>();
  const authWalletId = useAppSelector((state) => state.auth.authWallet?.id);
  const walletType = useAppSelector((state) => state.config.walletType);
  const permissions = useAppSelector((state) => state.auth.permissions);
  const transactionType = useAppSelector((state) => state.config.transactionType);
  const isFetchingMoveFunds = useAppSelector((state) => state.wallet.isFetchingMoveFunds);
  const [transTypeOptions, setTransTypeOptions] = useState<(TransactionType | undefined)[] | undefined>(undefined);
  const [selectedWallet, setSelectedWallet] = useState<Wallet | null>(null);
  const [selectedWalletInput, setSelectedWalletInput] = useState<string>("");
  const [amount, setAmount] = useState<string | undefined>(undefined);
  const [payloadData, setPayload] = useState<PayloadTransfer | undefined>(undefined);

  /////////////////////////
  const [isResultMenuVisible, setResultsMenuVisible] = useState(false);
  const [value, setValue] = useState("");

  const getSearchResults = (
    username: string,
  ) => {
    if (username.length >= 3) {
      (authWalletId &&
        dispatch(
          getFilteredSearchResultsRequested({
            id: authWalletId,
            params: {
              username: username,
            },
          })
        ),
        setResultsMenuVisible(true)
      )
    } else {
      setResultsMenuVisible(false);
    }


  };
  const handleCustomInputChange = (
    value: string,
  ) => {
    setValue(value)
    if (value.length) {
      getSearchResults(value)
    }
    else {
      dispatch(clearSearchResult());
      authWalletId &&
        dispatch(
          getWalletRequested({
            id: authWalletId,
            action: "new"
          })
        )
    }
  };

  const handleAmountChange = (value: string) => {
    setAmount(value)
  };

  const handleChange = (name: string, value: string | number) => {
    setPayload({
      ...payloadData,
      [name]: value,
    });
  };
  const handleTransfer = () => {
    !isFetchingMoveFunds &&
      selectedWallet !== null &&
      payloadData &&
      dispatch(
        moveFundsRequested({
          walletId: selectedWallet.id,
          data: {
            start_wallet_id: authWalletId,
            transaction_type_id: payloadData.transaction_type_id,
            amount: Number(amount)
          },
        })
      );
    selectedWallet !== null && setSelectedWallet(null)
    selectedWalletInput.length > 0 && setSelectedWalletInput("")
    value.length > 0 && setValue("")
    setPayload(undefined)
    setAmount(undefined)
    dispatch(clearSearchResult());
  };
  useEffect(() => {
    if (selectedWallet !== null) {
      const found = walletType?.find(
        (element: WalletType) => element.id === selectedWallet?.wallet_type_id
      );
      const canPerformTransactionType = found?.can_perform_transactiontype;
      const trxOptions: (TransactionType | undefined)[] | undefined =
        canPerformTransactionType?.map((opt: number) => {
          return transactionType?.find(
            (element: TransactionType) => element.id === opt
          );
        });
      setTransTypeOptions(trxOptions);
    }
  }, [selectedWallet]);

  return (
    <>
      {permissions &&
        checkWalletPermissions(permissions, "wallet.network") &&
        <Box
          ref={walletAccountUtilitiesRef}
          className={styles.walletAccountUtilities}>
          {/* {
            isFetchingMoveFunds &&
            <Box
              sx={{
                height: walletAccountUtilitiesRef &&
                  walletAccountUtilitiesRef.current &&
                  walletAccountUtilitiesRef.current.offsetHeight
              }}
              className={styles.backdrop}
            />
          } */}
          <Box
            className={styles.walletChildrenContainer}>
            {
              permissions &&
                checkWalletPermissions(permissions, "wallet.network") &&
                checkWalletPermissions(permissions, "game.betassist") ?
                <WalletChildrenSelect
                  selectedWallet={selectedWallet}
                  setSelectedWallet={setSelectedWallet}
                  selectedWalletInput={selectedWalletInput}
                  setSelectedWalletInput={setSelectedWalletInput}
                  type="accountMenu"
                />
                :
                permissions &&
                checkWalletPermissions(permissions, "wallet.network") &&
                <>
                  <TextField
                    value={value}
                    variant="outlined"
                    size="small"
                    fullWidth
                    name="wallet_id"
                    label={<Translate value="bettingFilter.username" />}
                    onChange={(e) => handleCustomInputChange(e.target.value)}
                    className={[styles.textfield, "form-label"].join(" ")}
                  />
                  <SearchResults
                    isResultMenuVisible={isResultMenuVisible}
                    setResultsMenuVisible={setResultsMenuVisible}
                    setValue={setValue}
                    setSelectedWallet={setSelectedWallet}
                  />
                </>
            }
          </Box>
          <Box className={styles.operationsContainer}>
            <TextField
              select
              name="transaction_type_id"
              value={payloadData?.transaction_type_id || ""}
              label={<Translate value="moveFunds.transaction_type_id" />}
              size="small"
              fullWidth
              required
              color="secondary"
              onChange={(event) => {
                handleChange(event.target.name, event.target.value)
              }}
              inputProps={{
                MenuProps: {
                  className: styles.selectMenu,
                },
              }}
              className={[styles.textfieldTrxOp, "form-label"].join(" ")}
            >
              {
                transTypeOptions?.map((option) => {
                  return (
                    <MenuItem
                      key={option?.label}
                      value={option?.id}
                      divider
                      className={styles.optionLabel} >
                      <Translate value={`moveFunds.${option?.label}`} />
                    </MenuItem>
                  )
                })
              }
            </TextField>
          </Box>
          <Box className={styles.amountFieldContainer}>
            <TextField
              value={amount || ""}
              name="amount"
              id="Amount"
              label={<Translate value="moveFunds.amount" />}
              size="small"
              fullWidth
              required
              onChange={(e) => {
                if (e.target.value === "" || NUMBER_REGEXP.test(e.target.value)) {
                  handleAmountChange(e.target.value.replace(",", "."))
                }
              }}
              className={[styles.textfield, "form-label"].join(" ")}
            />
          </Box>
          <Box className={styles.submitBtnContainer}>
            <Button
              onClick={handleTransfer}
              variant="contained"
              className={styles.button}
            >
              <Typography className={styles.proceedLabel}>
                <Translate value="buttons.proceed" />
              </Typography>
            </Button>
          </Box>
        </Box>
      }
      {
        isFetchingMoveFunds &&
        <Backdrop
          open={true}
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        />
      }
    </>
  )
}
export default WalletAccountUtilities;

interface ISearchResults {
  isResultMenuVisible: boolean;
  setValue: React.Dispatch<React.SetStateAction<string>>;
  setResultsMenuVisible: React.Dispatch<React.SetStateAction<boolean>>;
  setSelectedWallet: React.Dispatch<React.SetStateAction<Wallet | null>>;

}
function SearchResults({ isResultMenuVisible, setValue, setSelectedWallet, setResultsMenuVisible }: ISearchResults): ReactElement {
  const dispatch = useAppDispatch();
  const searchResults = useAppSelector((state) => state.wallet.searchResults);

  const handleRowMenu = (
    option: Wallet
  ) => {
    setSelectedWallet(option)
    setValue(
      ` ${option.name} (${option.balance.toFixed(2)}${option.currency.symbol})`
    );
    setResultsMenuVisible(false);
    dispatch(getWalletSucceded(option));
  };
  return (

    <Box className={styles.resultsContainer}>
      {isResultMenuVisible ? (
        searchResults && searchResults.length > 0 ? (
          searchResults.map((option: Wallet) => (
            <MenuItem
              key={option.id}
              value={option.name}
              className={styles.menuItem}
              divider
              onClick={() => handleRowMenu(option)}
            >
              <Typography className={styles.menuItemLabel}>{option.name}</Typography>
              <Box className={styles.menuItemBox}>
                <Typography className={styles.menuItemLabelAmount}>
                  <Translate value="nav.balance" />:&nbsp;
                  {`${option.balance.toFixed(2)}${option.currency.symbol}`}
                </Typography>
                <Typography className={styles.menuItemLabelAmount}>
                  <Translate value="nav.overdraft" />:&nbsp;
                  {`${option.overdraft.toFixed(2)}${option.currency.symbol}`}
                </Typography>
              </Box>
            </MenuItem>
          ))
        ) : (
          <Typography className={styles.noresult}>
            <Translate value="nav.noresult" />
          </Typography>
        )
      ) : null}
    </Box>
  )
}